import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="users"
export default class extends Controller {
  connect() {
    console.log("connected users")

    if(document.getElementById('renewal_date')){
      this.calculateRenewalDate()
    }
  }

  /*
   * Fetches the calculated renewal date from the server and displays it in the read-only
   * renewal_date field. Called on page connect (to show the current value) and whenever
   * remaining_months or current_start_date changes.
   *
   * The calculation is done server-side (ApplicationHelper#calculate_remaining_months) rather
   * than in JavaScript to ensure it uses the same date arithmetic logic as the Ruby code that
   * generates membership expiration dates in reports and the member list. This prevents
   * client/server divergence if the date math logic ever changes.
   */
  calculateRenewalDate() {
    var remaining_months = document.getElementById('user_remaining_months').value
    var current_year_start = document.getElementById('user_current_start_date').value

    $.ajax({
      type: "GET",
      url: '/users/calculate_remaining_months',
      data: { "remaining_months": remaining_months, "current_year_start": current_year_start },
      success: function(data) {

        if(data.status == 200) {
          document.getElementById('renewal_date').value = data.renewal_date
        } else {
          alert("Error Calculating Remaining Months")
        }
      }
    })
  }


  changeMembershipType(event) {
    var item = event.currentTarget

    if(item.value == 'charter_non_profit' || item.value == 'standard_non_profit'){
      document.getElementById('user_remaining_months').value = 23
    } else {
      document.getElementById('user_remaining_months').value = 11
    }

    this.calculateRenewalDate()
  }

  /*
   * Automatically adjusts the status dropdown when the permission level changes.
   * When a user is assigned the "host" permission level, their status is automatically
   * set to "host-hold" because hosts are typically not yet full active members of the chapter.
   *
   * We iterate through the options array to find the "host-hold" option rather than
   * setting selectElement.value directly, because the options loop is more reliable
   * across browsers when the select element has complex option structures.
   * For any non-host permission level, we reset to the first option (active) since the
   * automatic host-hold selection no longer applies.
   */
  changePermission(event) {
    var item = event.currentTarget
    const selectElement = document.getElementById('user_status');

    if(item.value == 'host') {
      const targetValue = 'host-hold';

      for (let i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].value === targetValue) {
          selectElement.options[i].selected = true;
          break;
        }
      }
    } else {
      selectElement.removeAttribute('disabled')
      selectElement.options[0].selected = true
    }
  }

  /*
   * Shows or hides contextual date fields based on the selected membership status.
   * Paused memberships require a start and end date for the pause period.
   * Cancelled memberships require a cancellation date for record-keeping.
   *
   * We always hide all conditional sections first (reset state) before showing the
   * relevant one. This prevents stale sections from staying visible when the admin
   * switches between statuses multiple times. The "active" alert warns the admin that
   * changing to active will trigger an activation email to the member — important because
   * that email goes out immediately on save, not on explicit confirmation.
   */
  changeStatus(event) {
    var item = event.currentTarget

    document.getElementById('paused_dates_start').classList.add('d-none')
    document.getElementById('paused_dates_end').classList.add('d-none')
    document.getElementById('cancelled_dates').classList.add('d-none')

    if(item.value == 'paused') {
      document.getElementById('paused_dates_start').classList.remove('d-none')
      document.getElementById('paused_dates_end').classList.remove('d-none')
    }

    if(item.value == 'cancelled') {
      document.getElementById('cancelled_dates').classList.remove('d-none')
    }

    if(item.value == 'active') {
      alert("Changing member to active will send them an email noting this change.")
    }
  }

  /*
   * Validates that the password and password_confirmation fields match in real time.
   * Toggles a success/error message and disables/enables the submit button accordingly
   * so the admin cannot submit a form with a password mismatch.
   *
   * We disable the submit button (rather than just showing an error) as a hard guard
   * because relying solely on a visual warning can be missed. Note: create_user_button
   * is referenced by ID (global reference) rather than the local `button` variable —
   * this is intentional since the button variable is captured before the conditional.
   */
  confirmPassword() {
    var success = document.getElementById('password_success')
    var error = document.getElementById('password_error')
    var password = document.getElementById('user_password')
    var confirm_password = document.getElementById('user_password_confirmation')
    var button = document.getElementById('create_user_button')

    if(password.value != confirm_password.value){
      success.classList.add('hidden')
      error.classList.remove('hidden')
      create_user_button.disabled = true
    } else {
      success.classList.remove('hidden')
      error.classList.add('hidden')
      create_user_button.disabled = false
    }
  }

  deleteUser(event) {
    var ans = confirm("Are you sure you want to delete this user?")
    if(ans) {
    } else {
      event.preventDefault()
    }
  }
}
